import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const overrideCountryAwardNominationScrubbing: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  nominationId: number,
  overrideJustification: string,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, countryId, nominationId, overrideJustification, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/scrubbing-status/override`,
  {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ overrideJustification }),
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'override country award nomination scrubbing'));
